module.exports = __webpack_public_path__ + "img/vcb.600b1716.png";